import styled from 'styled-components';
import type { TColorVariant } from '@klv/shared/styles/types';
import Grid from '@klv/utils/grid';
import { generateSpacingCSS } from '@klv/shared/utils/functions';

export const StyledFormsCta = styled.div<{ $backgroundColor: TColorVariant; }>`
    ${({ theme }) => theme.globalPadding};
    background: ${({ $backgroundColor, theme }) => theme.formsCta[$backgroundColor].background};
`;

export const ContentWrapper = styled(Grid)`
    width: 100%;
    padding: 0rem;
    ${({ theme }) => generateSpacingCSS(['padding-left', 'padding-right'], theme, [768, 992, 1024, 1200, 1366])};
`;

export const ImageWrapper = styled.div`
    grid-column: 1/-1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 2.4rem;
    ${({ theme }) => `
      ${theme.screenSize.s768.mediaQuery} {
        grid-column: 1/6;
        margin-bottom: 0rem;

      }
    `}
`;

export const StyledFormWrapper = styled.div<{ hasImage: boolean; }>`
    grid-column:1 / -1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${({ theme }) => generateSpacingCSS(['padding-left', 'padding-right'], theme, [380, 576])};
    ${({ theme, hasImage }) => `
      ${theme.screenSize.s768.mediaQuery} {
        ${hasImage ? 'grid-column: 7 / -1;' : 'grid-column: 4 / 10;'}
        padding: 0;  
      }
    `}
`;
